module.exports = __webpack_public_path__ + "static/magic-logo-167f0bf6aea8a0b1c912bb32cd8a8c68.png";